import { extend } from 'vee-validate'
import { required, min_value, length, email, is_not, numeric, max, min, regex } from 'vee-validate/dist/rules'

extend('minValue', {
  ...min_value,
  message: 'Minsta {_field_} är {min}'
})
extend('required', {
  ...required,
  message: '{_field_} måste fyllas i'
})
extend('length', {
  ...length,
  message: 'Skriv {_field_} med {length} siffror'
})
extend('email', {
  ...email,
  message: 'Ange en giltig epostadress'
})
const isValidSwedishSSN = (ssn) => {
    ssn = ssn
        .replace(/\D/g, "")     // strip out all but digits
        .split("")              // convert string to array
        .reverse()              // reverse order for Luhn
        .slice(0, 10);          // keep only 10 digits (i.e. 1977 becomes 77)

    // verify we got 10 digits, otherwise it is invalid
    if (ssn.length != 10) {
        return false;
    }

    var sum = ssn
        .map(function(n) { return Number(n); })
        .reduce(function(previous, current, index) {
            if (index % 2) current *= 2;
            if (current > 9) current -= 9;
            return previous + current;
        });
    return 0 === sum % 10;
};
extend('pnr', {
  validate: value => isValidSwedishSSN(value),
  message: 'Ange ett giltigt personnummer'
})
extend('is_not', {
  ...is_not,
  message: 'Välj en bank',
})
extend('numeric', {
  ...numeric,
  message: 'Skriv in {_field_} med enbart siffror'
})
extend('max', {
  ...max,
  message: '{_field_} får innehålla högst {length} tecken'
})
extend('min', {
  ...min,
  message: '{_field_} måste innehålla minst {length} tecken'
})
extend('regex', {
  ...regex,
  message: '{_field_} är på fel format'
})
extend('postalCode', {
  validate: value => value.replace(/\s/g, '').match(/\d{5}/) || value.match(/\d\*{3}/),
  message: 'Ange postnummer med 5 siffror'
})
extend('tel', {
  validate: value => value.match(/07\d{7,14}/),
  message: 'Ange telefonnummer enligt 07XXXXXXXX'
})
